import { render, staticRenderFns } from "./clipper-basic.vue?vue&type=template&id=06390267&scoped=true&"
import script from "./clipper-basic.vue?vue&type=script&lang=js&"
export * from "./clipper-basic.vue?vue&type=script&lang=js&"
import style0 from "./clipper-basic.vue?vue&type=style&index=0&id=06390267&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06390267",
  null
  
)

export default component.exports